







import Vue from "vue";
import { mapGetters } from "vuex";
import GetterTypes from "@/store/GetterTypes";

export default Vue.extend({
  name: "HasRole",
  props: {
    role: { type: String }
  },
  computed: {
    roleExists(): boolean {
      const show =
        this.user &&
        this.user.roles &&
        this.user.roles.some((r: string) => r === this.role);
      return show;
    },
    ...mapGetters({ user: GetterTypes.GET_USER })
  }
});
